import { Card } from "@/components/ui/card";
import { ChartPie, Users, TrendingUp } from "lucide-react";
import { PieChart, Pie, Cell, Tooltip, Legend } from "recharts";

interface CustomerBehaviorProps {
  data: any[];
}

export function CustomerBehavior({ data }: CustomerBehaviorProps) {
  // Análise de formas de pagamento
  const paymentMethods = data.reduce((acc: any, customer) => {
    customer.transactions?.forEach((transaction: any) => {
      if (transaction.type === "entrada") {
        acc[transaction.payment_method] = (acc[transaction.payment_method] || 0) + 1;
      }
    });
    return acc;
  }, {});

  const paymentMethodsData = Object.entries(paymentMethods).map(([name, value]) => ({
    name,
    value,
  }));

  // Frequência de compras
  const purchaseFrequency = data.reduce((acc: any, customer) => {
    const purchaseCount = customer.transactions?.filter(
      (t: any) => t.type === "entrada"
    ).length;

    let frequency = "Primeira compra";
    if (purchaseCount > 10) frequency = "Cliente frequente";
    else if (purchaseCount > 5) frequency = "Cliente regular";
    else if (purchaseCount > 1) frequency = "Cliente ocasional";

    acc[frequency] = (acc[frequency] || 0) + 1;
    return acc;
  }, {});

  const frequencyData = Object.entries(purchaseFrequency).map(([name, value]) => ({
    name,
    value,
  }));

  const COLORS = ["#0073B7", "#004080", "#E60026", "#F2F2F2"];

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2 text-[#0073B7]">
        <Users className="h-5 w-5" />
        <h3 className="text-lg font-semibold">Comportamento de Compra</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="rounded-lg border bg-card p-4">
          <h4 className="text-sm font-medium mb-4">Formas de Pagamento</h4>
          <PieChart width={300} height={300}>
            <Pie
              data={paymentMethodsData}
              cx={150}
              cy={150}
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {paymentMethodsData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </div>

        <div className="rounded-lg border bg-card p-4">
          <h4 className="text-sm font-medium mb-4">Frequência de Compras</h4>
          <PieChart width={300} height={300}>
            <Pie
              data={frequencyData}
              cx={150}
              cy={150}
              labelLine={false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {frequencyData.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </div>
      </div>
    </div>
  );
}